<template>
    <div class="shuxueDetail content-small-width">
        <el-row :gutter="22">
            <!-- 左侧部分 -->
            <el-col :span="6" class="left">
                <!-- <el-row>
                    <el-col :span="24">
                        <div class="img-bg">
                            <div class="one-book-title-box">皇帝内经</div>
                        </div>
                        <img src="../assets/img/jingluo.jpg" alt class="imgD" />
                    </el-col>
                </el-row>-->
                <el-row>
                    <el-col :span="24">
                        <div class="l-title">
                            <img src="../assets/img/jingluo.png" alt /> 腧穴的定位
                        </div>
                        <!-- <vue-scroll :ops="ops" style="height:260px"> -->
                            <ul class="l-ul">
                                <li
                                    @click="getDetail(item.id)"
                                    v-for="(item,index) in shuXueList"
                                    :key="index"
                                >{{limitMaxWords(10,item.name)}}</li>
                            </ul>
                        <!-- </vue-scroll> -->
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="adv-wrap">
                        <div
                            class="common-img-outer setPositon listdetail-adver-outer-img"
                            v-for="(item,index) in jingxueAdverList"
                            :key="index"
                        >
                            <a :href="item.urlLink">
                                <img :src="$store.state.imgUrl+item.urlImage" alt style="width:100%" />
                                <span class="adver-words-tip" v-if="item.urlImage">{{adverWordsTip}}</span>
                            </a>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <!-- 右侧部分 -->
            <el-col :span="18">
                <el-row>
                    <el-col :span="16">
                        <span class="large-title">{{name}}</span>
                        <!-- <span class="browse-count">浏览量：1136</span> -->
                    </el-col>
                    <!-- <el-col :span="8" class="btn-group text-right">
                        <el-button size="small" icon="el-icon-star-on" class="btn1 red">收藏</el-button>
                        <el-button size="small" icon="el-icon-share" class="btn1 grey">分享</el-button>
                    </el-col>-->
                </el-row>
                <!-- <el-row>
                    <el-col :span="24" class="jiangshi">
                        <span>教育类著作 年代：秦代 作者：秦代诸公</span>
                    </el-col>
                </el-row>-->

                <el-row>
                    <el-col :span="24" class="r-intro" v-html="zwnr"></el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    name: "shuxueDetail",
    data() {
        return {
            //  ops: {
            //         vuescroll: {},
            //         scrollPanel: {},
            //         rail: {
            //             keepShow:true
            //         },
            //         bar: {
            //             hoverStyle: true,
            //             onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
            //             background: '#ccc',
            //         }
            //     },
            name: "",
            zwnr: "",
            advList: [
                {
                    url: require("../assets/img/32.png")
                },
                {
                    url: require("../assets/img/33.png")
                }
            ]
        };
    },
    methods: {
        getDetail(id) {
            let that = this;
            let url = "/jlxw/sxdwf/get";
            let parmas = {
                id: id
            };
            that.$http
                .post(url, parmas)
                .then(res => {
                    if (res.data.code == 200) {
                        let arr = res.data.data;
                        that.name = arr.name;
                        that.zwnr = arr.zwnr;
                    } else {
                        that.$message(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message("网络错误！");
                });
        }
    },
    created() {
        let that = this;
        that.getPositionAdver(5, 3);
        that.getShuxueList();
        if (!!that.$route.query.id) {
            that.getDetail(that.$route.query.id);
        }
    }
};
</script>

<style scoped>
.img-bg {
    height: 360px;
    background-repeat: no-repeat;
    background-image: url("../assets/img/13.png");
}
.one-book-title-box {
    width: 50px;
    height: 160px;
    padding: 20px 0px;
    background-color: #ffffff;
    border: solid 1px #6c6b69;
    font-size: 22px;
    line-height: 40px;
    letter-spacing: 4px;
    color: #444444;
    position: absolute;
    top: 67px;
    left: 82px;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shuxueDetail.vue